import { useTheme } from '../context/ThemeContext';

export default function PublicShell({ children }) {
  const { currentTheme, toggleTheme } = useTheme();
  return (
    <div
      className={`cz-root ${currentTheme === 'light' ? 'lite' : ''}`}
      style={{
        minHeight: '100vh',
        background: 'var(--page-bg)',
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        color: 'var(--tx)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
      }}
    >
      <button
        type="button"
        onClick={toggleTheme}
        aria-label="Toggle theme"
        style={{
          position: 'fixed',
          top: 20,
          insetInlineEnd: 20,
          width: 44,
          height: 44,
          borderRadius: 14,
          background: 'linear-gradient(160deg, var(--s09), var(--s02))',
          border: '1px solid var(--s10)',
          color: 'var(--tx2)',
          cursor: 'pointer',
        }}
      >
        {currentTheme === 'light' ? '☀' : '☾'}
      </button>
      {children}
    </div>
  );
}
